import React from "react";

function BottomBar({
  onPreviousLeaderboard,
  onCurrentLeaderboard,
  onTransferMarket,
  onTeams,
  onRequestRoundTable,
  onAccountInfo,
  onTeamAccountInfo,
  socketData,
  onIndividualAnalysis,
  teamAccountData,
  onTeamAnalysis,
  onTeamLeaderboard,
}) {
  const stageId = socketData?.data?.stage_id || 0;

  const showPreviousLeaderboard = stageId == 1 || stageId == 2;
  const showCurrentLeaderboard = true;
  const showRoundTable = stageId && stageId >= 2;
  const showTransferMarket = stageId && stageId >= 2;
  const showTeams = stageId && stageId >= 2;
  const showAccountInfo = true;
  const showTeamAccountInfo = stageId && stageId > 1;
  const showTeamLeaderboard = true;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 backdrop-blur-xl border-t z-30"
      style={{
        backgroundColor: "rgba(17, 24, 39, 0.9)",
        borderColor: "rgba(55, 65, 81, 0.5)",
        boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.3)",
      }}
    >
      <div className="px-2 lg:px-4 xl:px-6 py-2 lg:py-3 flex items-center justify-between gap-1 lg:gap-2">
        {/* گروه اول - چپ: رده‌بندی‌ها + Transfer Market */}
        <div className="flex items-center gap-1 lg:gap-2">
          {showPreviousLeaderboard && (
            <button
              onClick={onPreviousLeaderboard}
              className="animated-button px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(251, 146, 60, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                مرحله 3
              </span>
              <div className="button-glow"></div>
            </button>
          )}

          {showCurrentLeaderboard && (
            <button
              onClick={onCurrentLeaderboard}
              className="animated-button-red px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(253, 13, 14, 0.3)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                رده‌بندی
              </span>
              <div className="button-glow-red"></div>
            </button>
          )}

          {showTeamLeaderboard && (
            <button
              onClick={onTeamLeaderboard}
              className="animated-button-pink px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(236, 72, 153, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 text-pink-400 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                رده‌بندی تیمی
              </span>
              <div className="button-glow-pink"></div>
            </button>
          )}

          {showTransferMarket && (
            <button
              onClick={onTransferMarket}
              className="animated-button-purple px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(168, 85, 247, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 text-purple-400 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                Transfer
              </span>
              <div className="button-glow-purple"></div>
            </button>
          )}
        </div>

        {/* خط جداکننده عمودی */}
        <div
          className="h-8 lg:h-10 xl:h-12 w-0.5 flex-shrink-0"
          style={{
            background:
              "linear-gradient(to bottom, transparent, rgba(253, 13, 14, 0.5), transparent)",
            boxShadow: "0 0 10px rgba(253, 13, 14, 0.3)",
          }}
        ></div>

        {/* گروه دوم - وسط: اطلاعات حساب‌ها + میز گرد */}
        <div className="flex items-center gap-1 lg:gap-2">
          {showAccountInfo && (
            <button
              onClick={onAccountInfo}
              className="animated-button-cyan px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(6, 182, 212, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 text-cyan-400 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                حساب فردی
              </span>
              <div className="button-glow-cyan"></div>
            </button>
          )}

          {showTeamAccountInfo && (
            <button
              onClick={onTeamAccountInfo}
              className="animated-button-teal px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(20, 184, 166, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 text-teal-400 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                حساب تیم
              </span>
              <div className="button-glow-teal"></div>
            </button>
          )}

          {showRoundTable && (
            <button
              onClick={onRequestRoundTable}
              className="animated-button-gold px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(234, 179, 8, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 text-yellow-400 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                میز گرد
              </span>
              <div className="button-glow-gold"></div>
            </button>
          )}
        </div>

        {/* خط جداکننده عمودی */}
        <div
          className="h-8 lg:h-10 xl:h-12 w-0.5 flex-shrink-0"
          style={{
            background:
              "linear-gradient(to bottom, transparent, rgba(253, 13, 14, 0.5), transparent)",
            boxShadow: "0 0 10px rgba(253, 13, 14, 0.3)",
          }}
        ></div>

        {/* گروه سوم - راست: پنل‌های آنالیز + تیم‌ها */}
        <div className="flex items-center gap-1 lg:gap-2">
          <button
            onClick={onIndividualAnalysis}
            className="animated-button-blue px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
          >
            <div
              className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: "rgba(59, 130, 246, 0.2)" }}
            >
              <svg
                className="w-3 h-3 lg:w-4 lg:h-4 text-blue-400 relative z-10 transform group-hover:scale-110 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
            <span className="relative z-10 font-semibold hidden xl:inline">
              آنالیز فردی
            </span>
            <div className="button-glow-blue"></div>
          </button>

          {showTeamAccountInfo && (
            <button
              onClick={onTeamAnalysis}
              className="animated-button-indigo px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(99, 102, 241, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 text-indigo-400 relative z-10 transform group-hover:scale-110 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                آنالیز گروهی
              </span>
              <div className="button-glow-indigo"></div>
            </button>
          )}

          {showTeams && (
            <button
              onClick={onTeams}
              className="animated-button px-2 lg:px-3 xl:px-4 py-1.5 lg:py-2 text-xs lg:text-sm text-white rounded-lg transition-all duration-300 flex items-center gap-1.5 lg:gap-2 backdrop-blur-sm border group relative overflow-hidden whitespace-nowrap"
            >
              <div
                className="w-5 h-5 lg:w-6 lg:h-6 xl:w-7 xl:h-7 rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: "rgba(34, 197, 94, 0.2)" }}
              >
                <svg
                  className="w-3 h-3 lg:w-4 lg:h-4 text-green-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a4 4 0 00-5-3.87M9 20H4v-2a4 4 0 015-3.87m6-6a4 4 0 11-8 0 4 4 0 018 0zM17 10h.01M21 10h.01M20 14h.01"
                  />
                </svg>
              </div>
              <span className="relative z-10 font-semibold hidden xl:inline">
                تیم‌ها
              </span>
              <div className="button-glow"></div>
            </button>
          )}
        </div>
      </div>

      <style>{`
        @keyframes glow {
          0%, 100% {
            opacity: 0.3;
            transform: scale(0.95);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.05);
          }
        }

        @keyframes shimmer {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .animated-button {
          background: linear-gradient(135deg, rgba(251, 146, 60, 0.2) 0%, rgba(251, 146, 60, 0.1) 100%);
          border-color: rgba(251, 146, 60, 0.4);
          position: relative;
          overflow: hidden;
        }

        .animated-button:hover {
          background: linear-gradient(135deg, rgba(251, 146, 60, 0.3) 0%, rgba(251, 146, 60, 0.2) 100%);
          border-color: rgba(251, 146, 60, 0.6);
          box-shadow: 0 0 20px rgba(251, 146, 60, 0.4);
          transform: translateY(-2px);
        }

        .animated-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          animation: shimmer 3s infinite;
        }

        .button-glow {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #fb923c, #f97316);
          border-radius: 12px;
          opacity: 0;
          filter: blur(10px);
          z-index: -1;
          animation: glow 2s ease-in-out infinite;
        }

        .animated-button-pink {
          background: linear-gradient(135deg, rgba(236, 72, 153, 0.25) 0%, rgba(236, 72, 153, 0.15) 100%);
          border-color: rgba(236, 72, 153, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-pink:hover {
          background: linear-gradient(135deg, rgba(236, 72, 153, 0.35) 0%, rgba(236, 72, 153, 0.25) 100%);
          border-color: rgba(236, 72, 153, 0.7);
          box-shadow: 0 0 25px rgba(236, 72, 153, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-pink::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2.6s infinite;
        }

        .button-glow-pink {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #ec4899, #db2777);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 2.1s ease-in-out infinite;
        }

        .animated-button-red {
          background: linear-gradient(135deg, rgba(253, 13, 14, 0.3) 0%, rgba(253, 13, 14, 0.15) 100%);
          border-color: rgba(253, 13, 14, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-red:hover {
          background: linear-gradient(135deg, rgba(253, 13, 14, 0.4) 0%, rgba(253, 13, 14, 0.25) 100%);
          border-color: rgba(253, 13, 14, 0.7);
          box-shadow: 0 0 25px rgba(253, 13, 14, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-red::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2.5s infinite;
        }

        .button-glow-red {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #fd0d0e, #dc2626);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 1.8s ease-in-out infinite;
        }

        .animated-button-cyan {
          background: linear-gradient(135deg, rgba(6, 182, 212, 0.25) 0%, rgba(6, 182, 212, 0.15) 100%);
          border-color: rgba(6, 182, 212, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-cyan:hover {
          background: linear-gradient(135deg, rgba(6, 182, 212, 0.35) 0%, rgba(6, 182, 212, 0.25) 100%);
          border-color: rgba(6, 182, 212, 0.7);
          box-shadow: 0 0 25px rgba(6, 182, 212, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-cyan::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2.7s infinite;
        }

        .button-glow-cyan {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #06b6d4, #0891b2);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 2.1s ease-in-out infinite;
        }

        .animated-button-teal {
          background: linear-gradient(135deg, rgba(20, 184, 166, 0.25) 0%, rgba(20, 184, 166, 0.15) 100%);
          border-color: rgba(20, 184, 166, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-teal:hover {
          background: linear-gradient(135deg, rgba(20, 184, 166, 0.35) 0%, rgba(20, 184, 166, 0.25) 100%);
          border-color: rgba(20, 184, 166, 0.7);
          box-shadow: 0 0 25px rgba(20, 184, 166, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-teal::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2.4s infinite;
        }

        .button-glow-teal {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #14b8a6, #0d9488);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 2.3s ease-in-out infinite;
        }

        .animated-button-gold {
          background: linear-gradient(135deg, rgba(234, 179, 8, 0.25) 0%, rgba(234, 179, 8, 0.15) 100%);
          border-color: rgba(234, 179, 8, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-gold:hover {
          background: linear-gradient(135deg, rgba(234, 179, 8, 0.35) 0%, rgba(234, 179, 8, 0.25) 100%);
          border-color: rgba(234, 179, 8, 0.7);
          box-shadow: 0 0 25px rgba(234, 179, 8, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-gold::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2.6s infinite;
        }

        .button-glow-gold {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #eab308, #ca8a04);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 2s ease-in-out infinite;
        }

        .animated-button-purple {
          background: linear-gradient(135deg, rgba(168, 85, 247, 0.25) 0%, rgba(168, 85, 247, 0.15) 100%);
          border-color: rgba(168, 85, 247, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-purple:hover {
          background: linear-gradient(135deg, rgba(168, 85, 247, 0.35) 0%, rgba(168, 85, 247, 0.25) 100%);
          border-color: rgba(168, 85, 247, 0.7);
          box-shadow: 0 0 25px rgba(168, 85, 247, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-purple::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2.8s infinite;
        }

        .button-glow-purple {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #a855f7, #9333ea);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 2.2s ease-in-out infinite;
        }

        .animated-button-blue {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.15) 100%);
          border-color: rgba(59, 130, 246, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-blue:hover {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.35) 0%, rgba(59, 130, 246, 0.25) 100%);
          border-color: rgba(59, 130, 246, 0.7);
          box-shadow: 0 0 25px rgba(59, 130, 246, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-blue::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 2.9s infinite;
        }

        .button-glow-blue {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 2.4s ease-in-out infinite;
        }

        .animated-button-indigo {
          background: linear-gradient(135deg, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0.15) 100%);
          border-color: rgba(99, 102, 241, 0.5);
          position: relative;
          overflow: hidden;
        }

        .animated-button-indigo:hover {
          background: linear-gradient(135deg, rgba(99, 102, 241, 0.35) 0%, rgba(99, 102, 241, 0.25) 100%);
          border-color: rgba(99, 102, 241, 0.7);
          box-shadow: 0 0 25px rgba(99, 102, 241, 0.5);
          transform: translateY(-2px);
        }

        .animated-button-indigo::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 3.1s infinite;
        }

        .button-glow-indigo {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, #6366f1, #4f46e5);
          border-radius: 12px;
          opacity: 0;
          filter: blur(12px);
          z-index: -1;
          animation: glow 2.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

export default BottomBar;